<template>
    <div>
        <DeleteModal :deleteModal="deleteModal" @init="init()"></DeleteModal>
        <div class="List">
            <!--查詢功能列-->
            <b-row>
                <b-col>
                    <!--使用者帳號-->
                    <b-form-input
                        placeholder="請輸入使用者帳號"
                        v-model="search.userAccount">
                    </b-form-input>
                </b-col>
                <b-col>
                    <!--姓名-->
                    <b-form-input
                        placeholder="請輸入姓名"
                        v-model="search.userName">
                    </b-form-input>
                </b-col>
                <b-col>
                    <!--群組-->
                    <b-form-select
                        class="only-button-down"
                        :options="groupOptions"
                        v-model="search.AG_ID">
                    </b-form-select>
                </b-col>
                <b-col>
                    <!--帳號啟用狀態-->
                    <b-form-select
                        class="only-button-down"
                        :options="statusOptions"
                        v-model="search.status">
                    </b-form-select>
                </b-col>
                <b-col cols="2">
                    <!--清除按鈕-->
                    <b-button @click="cancelSearch" v-if="checkSearchIsEmpty()" title="清空查詢條件">
                        <b-icon icon="x-circle"></b-icon>
                    </b-button>
                    <!--查詢按鈕-->
                    <b-button @click="startSearch" title="開始查詢">
                        <b-icon icon="search"></b-icon>
                    </b-button>
                </b-col>
                <b-col cols="2">
                    <!--新增按鈕-->
                    <b-button
                    @click="gotoContent()" >
                        新增
                    </b-button>
                </b-col>
            </b-row>
            <!--列表本體-->
            <b-container>
                <b-table-simple>
                    <b-thead>
                        <b-th>使用者帳號</b-th>
                        <b-th>姓名</b-th>
                        <b-th>群組</b-th>
                        <b-th>帳號狀態</b-th>
                        <b-th>建檔日期</b-th>
                        <b-th >修改</b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="item in DataList" :key="item.userId" v-if="blacklist.filter(x =>x.value == item.userAccount).length == 0  ||blacklist.filter(x => x.value == userAccount).length == 1 ">
                            <b-td>{{ item.userAccount }}</b-td>
                            <b-td>{{ item.userName }}</b-td>
                            <b-td>{{ item.AG_Name }}</b-td>
                            <b-td>{{ item.statusName }}</b-td>
                            <b-td>{{ dateFormat(item.createDate) }}</b-td>
                            <!--功能按鈕-->
                            <b-td>
                                <b-button 
                                    class="mr-5"
                                    variant="info"
                                    @click="gotoContent(item.userId)">
                                    編輯
                                </b-button>
                                <a href="javascript:void(0)"
                                    class="btn-delete"
                                    v-if="blacklist.filter(x =>x.value == item.userAccount).length == 0 "
                                    @click="functionDelete(item)">
                                   <img src="/images/backend/del_icon.png" alt="刪除icon" />
                                </a>
                            </b-td>   
                        </b-tr>     
                    </b-tbody>
                </b-table-simple>
            </b-container>
            <div class="page mt-2">
                <span class="pagination-total">共 {{Math.ceil(pagination.rows/pagination.perPage)}} 頁．{{pagination.rows}}筆資料</span>
                <b-pagination
                class="pagination light-theme simple-pagination"
                v-model="pagination.page"
                :total-rows="pagination.rows"
                :per-page="pagination.perPage"
                aria-controls="my-table">
                </b-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import DeleteModal from '../../Tool/deleteModal.vue';
export default{ 
    components:{
        DeleteModal,
    },
    data(){
        return{
            //類別編號
            PJ_ID:"",
            //樣式編號
            modal:"",
            //群組選項
            groupOptions:[],
            //啟用選項
            statusOptions:[
                {value: null ,text:"請選擇帳號狀態"},
                {value: 0 ,text:"停用"},
                {value: 1 ,text:"啟用"},
            ],
            //查詢資訊
            search:{status:null ,AG_ID:null},
            //列表設定
            pagination: {
                perPage: 10,
                page: 1,
                rows: 5,
            },
            //刪除模板
            deleteModal: {
                id: null,
                classes: null,
                parent: null,
                show: false,
                type: "Account",
            },
            //排除帳號
            blacklist:[
                {value:"sysmanager"},
            ],
            //目前登入帳號
            userAccount:"",
            //列表資料
            DataList:[],
        };
    },
    props:["value"],
    computed:{
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
    },
    methods:{
        //初始化
        init(){
            //類別編號
            this.PJ_ID = this.value.PJID;
            //樣式編號
            this.modal = this.value.modal;
            //取得所有群組項目
            this.getGroup();
            //開始查詢
            this.startSearch();
            this.userAccount = sessionStorage.getItem('LoginAcc');
        },
        //取得所有群組項目
        async getGroup(){
            try{
                //初始預設
                this.groupOptions.push({value:null, text:"請選擇所屬群組"});
                //POST 參數
                let jsonReq={
                    TYPE:"GROUP_OPTION",
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                let res = await this.userRequest.post("bicd/UserInfo",jsonReq); 
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData.length >0){
                        jsonData.forEach((item)=>{
                            this.groupOptions.push({value:item.key,text:item.value});
                        });
                    }
                }
            }catch(err){
                console.log("ErrFunction: getGroup/n "+err);
            }
        },
        //開始查詢
        async startSearch(){
            try{
                //POST 參數
                let jsonReq = {
                    TYPE:"LIST",
                    VerifyCode: this.PJ_ID,
                    user_info_SELECT: {
                        userName: this.search.userName,
                        userAccount: this.search.userAccount,
                        AG_ID: this.search.AG_ID,
                        status: this.search.status,
                        pageIndex: this.pagination.page,
                        pageSize: this.pagination.perPage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/UserInfo",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    this.DataList = jsonData.outData;
                    this.pagination.rows = jsonData.totalCount;
                }
            }catch(err){
                console.log("ErrFunction: startSearch/n "+err);
            }
        },
        //跳轉至編輯頁面
        gotoContent(gotoid=0){
            this.$router.replace({
                path: this.$route.path,
                query:{
                    PJID:this.$route.query.PJID,
                    modal:3,
                    id:gotoid,
                }
            });
        },
        //清除查詢資訊
        cancelSearch(){
            //清空查詢條件
            this.search={status:null ,AG_ID:null};
            //重新查詢事件
            this.startSearch();
        },
         //刪除功能
        functionDelete(item) {
            this.deleteModal.show = true;
            this.deleteModal.id = item.userId;
            this.deleteModal.type = "Account";
            this.deleteModal.langurage = 1;
            this.deleteModal.VerifyCode = this.PJ_ID;
        },
    }
}
</script>